/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlannerItineraryReorderItem } from './PlannerItineraryReorderItem';
import {
    PlannerItineraryReorderItemFromJSON,
    PlannerItineraryReorderItemFromJSONTyped,
    PlannerItineraryReorderItemToJSON,
    PlannerItineraryReorderItemToJSONTyped,
} from './PlannerItineraryReorderItem';

/**
 * 
 * @export
 * @interface PlannerItineraryReorderRequest
 */
export interface PlannerItineraryReorderRequest {
    /**
     * 
     * @type {Array<PlannerItineraryReorderItem>}
     * @memberof PlannerItineraryReorderRequest
     */
    items: Array<PlannerItineraryReorderItem>;
}

/**
 * Check if a given object implements the PlannerItineraryReorderRequest interface.
 */
export function instanceOfPlannerItineraryReorderRequest(value: object): value is PlannerItineraryReorderRequest {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function PlannerItineraryReorderRequestFromJSON(json: any): PlannerItineraryReorderRequest {
    return PlannerItineraryReorderRequestFromJSONTyped(json, false);
}

export function PlannerItineraryReorderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerItineraryReorderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PlannerItineraryReorderItemFromJSON)),
    };
}

export function PlannerItineraryReorderRequestToJSON(json: any): PlannerItineraryReorderRequest {
    return PlannerItineraryReorderRequestToJSONTyped(json, false);
}

export function PlannerItineraryReorderRequestToJSONTyped(value?: PlannerItineraryReorderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(PlannerItineraryReorderItemToJSON)),
    };
}

